export default function RolePage() {
  return <div>role</div>;
}
